import { OBJLoader, MTLLoader } from "three-obj-mtl-loader";
import { Server } from "../Server/Server";
function loadOBJ() {
}
loadOBJ.prototype = {
  constructor: loadOBJ,
  server:new Server(),
  modelPath:"",
  mapsPath:"",
  progressCallBack:null,
  loadObjectFinishCallback:null,
  //加载模型
  load: function (modelPath, mapsPath, progressCallBack,loadObjectFinishCallback) {
    this.mapsPath=mapsPath;
    this.modelPath=modelPath;
    this.progressCallBack=progressCallBack;
    this.loadObjectFinishCallback=loadObjectFinishCallback;
    if (mapsPath == "") {
      let objLoader = new OBJLoader();
      objLoader.setPath(
        modelPath.substring(
          0,
          modelPath.lastIndexOf("/")
        )
      );
      objLoader.load(
        modelPath.substring(
          modelPath.lastIndexOf("/")
        ),
        (obj) => {
          loadObjectFinishCallback(obj);
        },
        (xhr) => {
          progressCallBack(xhr);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      let mtlPath=mapsPath+modelPath.substring(modelPath.lastIndexOf("/") + 1, modelPath.lastIndexOf(".")) + ".mtl";
      // this.checkFileExitsCallback.bind(this);
      this.server.isFileExits(mtlPath,(data)=>{this.checkFileExitsCallback(data)});
    }
  },
  checkFileExitsCallback:function(data){
    if(data.data.isExits){
      let objLoader = new OBJLoader();
      let mtlLoader = new MTLLoader();
      mtlLoader.setPath(
        this.mapsPath
      );
      
      mtlLoader.load(
        this.modelPath.substring(this.modelPath.lastIndexOf("/") + 1, this.modelPath.lastIndexOf(".")) + ".mtl",
        (materials) => {
          
          materials.preload();
          objLoader.setMaterials(materials);
          objLoader.setPath(this.modelPath.substring(0, this.modelPath.lastIndexOf("/")));
          objLoader.load(
            this.modelPath.substring(this.modelPath.lastIndexOf("/")),
            (obj) => {
             this.loadObjectFinishCallback(obj);
            },
            (xhr) => {
              this.progressCallBack(xhr);
            },
            (error) => {
              console.log(error)
            }
          );
        }
      );
    }else{
      let objLoader = new OBJLoader();
      objLoader.setPath(this.modelPath.substring(0, this.modelPath.lastIndexOf("/")));
          objLoader.load(
            this.modelPath.substring(this.modelPath.lastIndexOf("/")),
            (obj) => {
             this.loadObjectFinishCallback(obj);
            },
            (xhr) => {
              this.progressCallBack(xhr);
            },
            (error) => {
              console.log(error)
            }
          );
    }
  }
}
export {
  loadOBJ
}